import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type ValidateInviteResponse = IApiResponse<{ valid: boolean }>;
export type ValidateInviteInput = {
  readonly email: string;
  readonly token: string;
};

/**
 * Pre-flight check for the universal sign-up form. Resolves to `{ valid: true }`
 * when the invite is still active; throws on 403 when the token is unrecognized
 * or the underlying `Invited` CompanyMemberRole row was deleted (i.e. the inviter
 * revoked the invitation from Team).
 *
 * Callers should treat any rejection as "invitation no longer valid" and steer
 * the user away from the password form rather than re-trying. Backed by the
 * shared `assertInviteIsStillValid` helper in la-forge so the pre-flight cannot
 * disagree with `/api/createAccount`.
 */
export const validateInvite = (axios: IAxiosInstance) => {
  return async (options: ValidateInviteInput) => {
    const response = await axios.noRetry.post<ValidateInviteResponse>(
      `/api/validateInvite`,
      {
        email: options.email,
        token: options.token,
      }
    );

    return response.data.data;
  };
};
